import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-020284d0"), n = n(), _popScopeId(), n);
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shimmer-loader shimmer-row tw-mb-10px"
}, null, -1 /* HOISTED */));
var _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shimmer-loader shimmer-row tw-mb-10px"
}, null, -1 /* HOISTED */));
var _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shimmer-loader shimmer-row tw-mb-10px"
}, null, -1 /* HOISTED */));
var _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.multipleRowText ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["shimmer-loader", _ctx.containerClass]),
    style: _normalizeStyle(_ctx.containerStyle)
  }, null, 6 /* CLASS, STYLE */));
}